(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vendo-contact"] && !Shopify.designMode) return;
  try {
    

function getRandomInt() {
  return Math.floor(Math.random() * 8) + 1;
}

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('contact_form');

  const firstValue = getRandomInt();
  const secondValue = getRandomInt();
  const questionString = `Bitte Ergebnis von ${firstValue} + ${secondValue} eingeben`;

  const question = document.getElementById('spam_question');
  question.value = questionString;
  const result = document.getElementById('spam_result');
  result.querySelector('input').placeholder = questionString;
  result.querySelector('label').innerHTML = questionString;
  
  const successMessage = document.getElementById('contact_form_success');
  const errorMessage = document.getElementById('contact_form_error');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const url = 'https://mailservice.tripp.agency/api/vendo';

    const formData = new FormData(form);
    const response = await fetch(url, {
      method: 'POST',
      body: formData
    });

    const json = await response.json();
    if (json.status === 'OK') {
      successMessage.classList.remove('hidden');
    } else {
      errorMessage.classList.remove('hidden');
    }
  });
})


  } catch(e) { console.error(e); }
})();
})();
